import { render, staticRenderFns } from "./ContractAcceptedMessage.vue?vue&type=template&id=01ff7510&scoped=true&"
import script from "./ContractAcceptedMessage.vue?vue&type=script&lang=js&"
export * from "./ContractAcceptedMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ff7510",
  null
  
)

export default component.exports